import {DOCUMENT} from '@angular/common';
import {Inject, Injectable, NgZone} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InjectorService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private zone: NgZone,
  ) {}

  add(src: string, id: string = 'analytics-script', async = false, webComponent = false) {
    return new Observable((ret) => {
      const htmlScript: HTMLScriptElement = this.document.createElement('script');
      htmlScript.src = src;
      htmlScript.id = id;
      htmlScript.async = async;
      //htmlScript.crossOrigin = 'use-credentials';
      if (webComponent) {
        this.zone.run(() => {
          this.document.head.insertBefore(htmlScript, this.document.head.firstChild);
        });
      } else {
        this.zone.runOutsideAngular(() => {
          this.document.head.insertBefore(htmlScript, this.document.head.firstChild);
        });
      }
      htmlScript.addEventListener('load', (evt) => {
        ret.next(evt);
        ret.complete();
      });
      htmlScript.addEventListener('error', (evt) => {
        ret.error(evt);
        ret.complete();
      });
    });
  }

  hasScript(src: string) {
    const lastPart = src.split('/').pop();
    return this.document.querySelectorAll(`script[src$="${lastPart}"]`).length > 0;
  }
}
